import { render } from "./CertificateDetails.vue?vue&type=template&id=377df3e3&scoped=true"
import script from "./CertificateDetails.vue?vue&type=script&lang=js"
export * from "./CertificateDetails.vue?vue&type=script&lang=js"

import "./CertificateDetails.vue?vue&type=style&index=0&id=377df3e3&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377df3e3"]])

export default __exports__